import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/app/environments/environment';
import { Observable } from 'rxjs';
import { IUser } from '../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class ExternalHeaderService {
  private http = inject(HttpClient);


  private userUrl = `${environment.apiUrl}/users`;


  constructor() {
  }

  getUser( id: string ): Observable<IUser> {
    const url = `${this.userUrl}/${id}`;
    return this.http.get<IUser>( url );
  }
}
